import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./auth";

function PrivateRoute({ component: Component, render, ...rest }) {
  const { authTokens } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authTokens) {
          return <Redirect to="/" />;
        }

        // ✅ If a render prop is supplied, use it
        if (render) {
          return render(props);
        }

        // ✅ Otherwise fall back to component prop (existing behaviour)
        if (Component) {
          return <Component {...props} />;
        }

        return null;
      }}
    />
  );
}

export default PrivateRoute;
